import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SkillType } from '@src/types/shared/skill_type';
import type { RootState } from '..';

type State = {
  type: SkillType;
};

const initialState: State = {
  type: 'creator',
};
const skillTypeSlice = createSlice({
  name: 'skillType',
  initialState,
  reducers: {
    updateSkillType(state: State, action: PayloadAction<SkillType>) {
      state.type = action.payload;
    },
  },
});

export const { updateSkillType } = skillTypeSlice.actions;

export const selectSkillType = (state: RootState) => state.skillType.type;

export default skillTypeSlice.reducer;
